import React from 'react'
import { useData } from './DataProvider'
import { NavButton, ButtonContainer } from './Buttons'
import useTranslation from '../shared/TranslationProvider'
import InterestSelect from './InterestSelect'
import StepProgressHeading from './StepProgressHeading'
import { stepDescribedBy } from './stepProgress'

const Step2 = () => {
  const { interest, setCurrentStep, step } = useData()
  const { t } = useTranslation()
  const interestHeadingId = 'onboarding-interest-heading'
  const interestDescriptionId = 'onboarding-interest-description'

  return (
    <>
      <div className="pt-10" data-testid="a11y-onboarding--step-2">
        {/* CTS-9266 — YNS-020: one h1 per step */}
        <h1
          id={interestHeadingId}
          data-onboarding-step-heading
          tabIndex={-1}
          aria-describedby={stepDescribedBy(interestDescriptionId)}
          className="text-2xl font-bold focus:outline-none md:text-4xl"
        >
          {t('looking_for')}
        </h1>
        <StepProgressHeading>
          {t('stepper_progress', { current: step })}
        </StepProgressHeading>
        <p id={interestDescriptionId} className="py-4 text-base md:text-xl">
          {t('interested_in')}
        </p>
        <InterestSelect
          labelledBy={`${interestHeadingId} ${interestDescriptionId}`}
        />
      </div>
      <ButtonContainer>
        <NavButton type={'back'} onClick={() => setCurrentStep(1)}>
          {t('back')}
        </NavButton>
        <NavButton
          type={'submit'}
          disabled={interest === null}
          onClick={() => setCurrentStep(3)}
        >
          {t('next')}
        </NavButton>
      </ButtonContainer>
    </>
  )
}

export default Step2
